import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toIcons } from "../../consts/Paths";
import MainContext from "../../context/MainContext";
import useIsMobile from "../../hooks/useIsMobile";
import "../../styles/ModelDetails.css";

const ModelDetailsHeader = (props: any) => {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();

  const { setModel } = useContext(MainContext);

  const handelClickOnEdit = () => {
    setModel(props.model);
    navigate(`/models/${props.model.id}/edit`);
  };

  /*  const handleClickOnComposite = () => {
    if (props.model?.composite) {
      window.open(props.model.composite);
    }
  }; */
  /*   const handleClickOnLookbook = () => {
    if (props.model?.lookbook) { 
       window.open(props.model.lookbook);  
    }
  }; */

  return (
    <div
      className="general-header"
      style={{
        margin: isMobile ? "30px auto 0" : "",
        width: "90%",
      }}
    >
      <div className="Oval" onClick={() => navigate(`/models`)}>
        <img src={`${toIcons}/small-left.svg`} />
      </div>
      <div
        className="general-header-right"
        style={{
          marginLeft: isMobile ? "21px" : "",
        }}
      >
        <div className="header-right-box1">
          <a href={props.model?.composite} download target={"_blank"}>
            <div className="Oval" /* onClick={handleClickOnComposite} */>
              <img
                className={`${
                  props.model?.composite ? "offLightBlue" : "grey"
                } `}
                src={`${toIcons}/composite.svg`}
              />
            </div>
          </a>
          <div>
            <a href={props.model?.lookbook} download target={"_blank"}>
              <div className="Oval" /* onClick={handleClickOnLookbook} */>
                <img
                  className={`${
                    props.model?.lookbook ? "offLightBlue" : "grey"
                  } `}
                  src={`${toIcons}/lookbook.svg`}
                />
              </div>
            </a>
          </div>
        </div>
        <div className="header-right-box2" style={{ gap: isMobile ? "0" : "" }}>
          <button
            className="button3"
            onClick={props.togglerProposalModal.toggle}
            style={{ width: isMobile ? "58px" : "122px" }}
          >
            {isMobile ? (
              <img className="offLightBlue" src={`${toIcons}/plus.svg`} />
            ) : (
              <p className="button3-text">Add to proposal</p>
            )}
          </button>
          <button
            className="button1"
            onClick={handelClickOnEdit}
            style={{ width: isMobile ? "58px" : "122px" }}
          >
            <img className="white" src={`${toIcons}/edit.svg`} />
            {!isMobile && <p className="button1-text">Edit</p>}
          </button>
        </div>
      </div>
    </div>
  );
};
export default ModelDetailsHeader;
